import { SectionHeader } from '../common/SharedComponents';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';

function AsssessmentLanding() {
    const styles = {
        linkPaper: {
            color: '#2C5591',
            textAlign: 'center',
            padding: 50,
            fontSize: 14,
            margin: 20,
            width: 300,
        },
        loginPaper: {
            color: '#2C5591',
            padding: 20,
            fontSize: 14,
            margin: 20,
        },
        flexContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            overflow: 'auto',
        },
        verticalPadding: {
            paddingTop: 50,
            paddingBottom: 50,
        },
    };

    return (
        <>
            <SectionHeader
                title='Assessments'
                buttonText=''
            />
            <div
                className='main-content'
                style={{ padding: 0 }}
            >
                <div
                    className='row scrollable-content'
                    style={styles.flexContainer}
                >
                    <Link
                        to='/assessment/experiencerules'
                        style={styles.verticalPadding}
                    >
                        <Paper
                            style={styles.linkPaper}
                            elevation={3}
                        >
                            <h1>Experience Rules</h1>
                            <p>View/Update Experience Rules</p>
                        </Paper>
                    </Link>
                    <Link
                        to='/assessment/experiencelevels'
                        style={styles.verticalPadding}
                    >
                        <Paper
                            style={styles.linkPaper}
                            elevation={3}
                        >
                            <h1>Experience Levels</h1>
                            <p>View/Update Experience Levels</p>
                        </Paper>
                    </Link>
                </div>
            </div>
        </>
    );
}

export default AsssessmentLanding;
